import type { SVGProps } from 'react';
const SvgFastForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fast_forward_svg__a)">
      <path fill="currentColor" d="m4 18 8.5-6L4 6v12Zm9-12v12l8.5-6L13 6Z" />
    </g>
    <defs>
      <clipPath id="fast_forward_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFastForward;
